import { OverlayContainer } from '@angular/cdk/overlay';
import {
  ElementRef,
  Injectable,
  Injector, Renderer2,
} from '@angular/core';
import { take, tap } from 'rxjs/operators';
import {ApActiveModal} from './ApActiveModal';
import { ApDialogRef } from './ApDialogConfig';

import {ApModalHelper} from './ApModalHelper';

import { DialogRef } from '@angular/cdk/dialog';

@Injectable({
  providedIn: 'root',
})
export class ApModalHelperFactory {

  // This should be the injector from the component, not an Injector
  // injected directly into a service.
  create<T>(
    elementInjector: Injector,
    hideHandler: (reason: string) => void,
  ): ApModalHelper<T> {
    const dialogRef = elementInjector.get(DialogRef) as ApDialogRef;
    const activeModal = elementInjector.get<ApActiveModal<T>>(ApActiveModal);
    const closeTeardown = dialogRef.closed.pipe(
      take(1),
      tap(() => {
        hideHandler('closeAll(), ngOnDestroy(), escape, backdrop-click, or overlay-detached');
      }),
    ).subscribe();
    activeModal.setup(
      dialogRef,
      () => {
        closeTeardown.unsubscribe();
      },
    );
    const modalHelper = new ApModalHelper<T>(
      activeModal,
      elementInjector.get(Renderer2),
      elementInjector.get(ElementRef),
      elementInjector.get(OverlayContainer),
    );
    return modalHelper;
  }
}
